import { RosterPlayer } from "../types";

export const getCellKey = (
  quarter: string,
  minute: number,
  slot: number
): string => `${quarter}-${minute}-${slot}`;

export const getPlayerForCell = (
  quarter: string,
  minute: number,
  slot: number,
  slotAssignments: Record<string, number | null>,
  roster: RosterPlayer[]
): RosterPlayer | null => {
  const key = getCellKey(quarter, minute, slot);
  const playerId = slotAssignments[key];
  if (!playerId) return null;
  return roster.find((p) => p.playerId === playerId) || null;
};

export const getInitials = (playerName: string): string => {
  const [firstName, lastName] = playerName.split(" ");
  return `${firstName[0]}${lastName[0]}`;
};
